import Color from 'color'

const query = window.location.search

export function getQueryParams () {
  if (!/^\?/.test(query)) {
    return {}
  }

  return query
    .substring(1)
    .split('&')
    .reduce((params, param) => {
      const [key, value] = param.split('=')
      return {
        ...params,
        [key]: value,
      }
    }, {})
}

/**
 * Generates a random pastel color in HSLA format
 * @returns a color in HSLA format
 */
function generateRandomPastelColor () {
  return `hsla(${Math.floor(360 * Math.random())}, 70% , 70%, 0.8)`
}

export function getChartStyles (usedColors) {
  let color

  do {
    color = Color(generateRandomPastelColor())
  } while (usedColors.includes(color))

  usedColors.push(color)
  const bgColor = Color(color.hex()).alpha(0.2)

  return {
    fill: true,
    backgroundColor: bgColor.toString(),
    borderColor: color.hex(),
    pointBackgroundColor: color.hex(),
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: color.hex(),
  }
}
